/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Mixdown_ProgressInputs */

const en_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio mixdown in progress... ${i?.timecode}`)
};

const fr_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixdown en cours... ${i?.timecode}`)
};

const de_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audiomixdown läuft... ${i?.timecode}`)
};

const it_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixaggio audio in corso... ${i?.timecode}`)
};

const ru_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ведется сведение звука... ${i?.timecode}`)
};

const es_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mezcla de audio en progreso... ${i?.timecode}`)
};

const zh_cn2_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频混音进行中……${i?.timecode}`)
};

const ja_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオミックスダウン進行中... ${i?.timecode}`)
};

const hi_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो मिक्सडाउन जारी है... ${i?.timecode}`)
};

const pt_pt2_audio_description_export_status_mixdown_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixagem de áudio em andamento... ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Audio mixdown in progress... {timecode}" |
*
* @param {Audio_Description_Export_Status_Mixdown_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixdown_progress = /** @type {((inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixdown_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "de") return de_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "it") return it_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "ru") return ru_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "es") return es_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "ja") return ja_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "hi") return hi_audio_description_export_status_mixdown_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_mixdown_progress(inputs)
	return en_audio_description_export_status_mixdown_progress(inputs)
});